import React, { createContext, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { useGetSingleFormDataQuery } from "modules/pvs_activities/redux/service/formData";
import { isNumeric } from "modules/pvs_activities/helper.general";

export const FormDataContext = createContext();

const defaultProps = {
    mode: "preview",
    templateId: "",
    sectionId: "",
    movementId: "",
    missionId: "",
    formType: "FT_FRM",
    movementStatus: 0,
    children: "",
    isReadOnly: null,
    elementsData: {},
    setElementsData: () => {},
};

const FormContext = (rawProps) => {

    const props = { ...defaultProps, ...rawProps };

    const formDataRes = useGetSingleFormDataQuery(
        {
            sectionId: isNumeric(props.sectionId) ? props.sectionId : 0,
            movementId: props.movementId
        },
        {
            skip: props.mode === "preview" || ["", null, undefined].includes(props.sectionId),
            refetchOnMountOrArgChange: true,
        }
    );

    const [elementsData, setElementsData] = useState({});

    const isReadOnly = useMemo(() => {
        if (props.isReadOnly !== null) return true;
        return props.mode === "data_entry" ? [2, 6].includes(props.movementStatus) : false;
    }, [props.isReadOnly, props.movementStatus, props.mode]);

    const contextValue = useMemo(() => {
        if (props.mode === "data_entry") {
            if (formDataRes.isLoading) return defaultProps;
            if (formDataRes.isError) return defaultProps;
        }
        return {
            mode: props.mode,
            elementsData: props.mode === "data_entry" ? formDataRes.data : elementsData,
            formType: props.formType,
            templateId: props.templateId,
            sectionId: props.sectionId,
            movementId: props.mode === "data_entry" ? props.movementId : "",
            missionId: props.mode === "data_entry"
                ? props.missionId
                    ? props.missionId
                    : ""
                : "",
            isReadOnly: isReadOnly,
            setElementsData: props.mode === "preview" ? setElementsData : () => { },
        };
    }, [formDataRes, props.mode, elementsData, setElementsData, props.missionId]);

    return <FormDataContext.Provider value={contextValue}>{props.children}</FormDataContext.Provider>;
};

FormContext.propTypes = {
    mode: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf(["preview", "data_entry"])]).isRequired,
    templateId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    sectionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    movementId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    missionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    formType: PropTypes.string,
    movementStatus: PropTypes.number,
    children: PropTypes.any,
};

export default FormContext;
